module.exports = __webpack_public_path__ + "img/treatment-wetlands-text.b754285c.svg";